<template>
  <div>
    <card>
      <template slot="header">
        <h4 class="card-title">Bienvenido al Portal de envío de pagos y multas</h4>
      </template>
    </card>

    <v-card class="my-5" elevation="8">
      <v-card-title>
        Estadísticas de Pago Vocales
        <v-spacer></v-spacer>
        <v-select
              v-model="eleccionSelected"
              :items="elecciones"
              item-value="nombre_corto"
              item-text="nombre_completo"
              label="Elección"
              @change="cargarEstadisticas()"
              outlined
              dense
              chips
              deletable-chips
            />
      </v-card-title>
      <v-card-text>

        <v-row>
          <v-col cols="3">
            <v-card class="text-center" elevation="16" color="amber darken-1">
              <v-card-title class="white--text">Pagos Creados</v-card-title>
              <v-card-text class="white--text">
                <h1>
                  {{ estadisticas.creados || 0 }}
                </h1>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card class="text-center" elevation="16" color="blue darken-1">
              <v-card-title class="white--text">Encolados para envío</v-card-title>
              <v-card-text class="white--text">
                <h1>
                  {{ estadisticas.encolados || 0 }}
                </h1>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card class="text-center" elevation="16" color="success">
              <v-card-title class="white--text">Enviados a TGR</v-card-title>
              <v-card-text class="white--text">
                <h1>
                  {{ estadisticas.enviados || 0 }}
                </h1>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card class="text-center" elevation="16" color="error">
              <v-card-title class="white--text">Con errores</v-card-title>
              <v-card-text class="white--text">
                <h1>
                  {{ estadisticas.errores || 0 }}
                </h1>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { PagoVocalesService } from "../util/Api/PagoVocales/calls";

export default {
  data() {
    return {
      loadingInstance: null,
      estadisticas: {
        creados: 0,
        encolados: 0,
        enviados: 0,
        errores: 0
      },
      elecciones:[],
      eleccionSelected:null,
    };
  },

  mounted() {
    this.getElecciones();
    this.cargarEstadisticas();
  },

  methods: {
    async getElecciones() {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });
        this.elecciones = await PagoVocalesService.getElecciones();

        this.loadingInstance.close();
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar la lista de elecciones: ${error}`,
        });
      }
    },
    async cargarEstadisticas() {
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: 'Cargando estadísticas...',
        background: 'rgba(0, 0, 0, 0.8)'
      });

      try {
        // Preparar parámetros para la consulta
        const params = {};
        if (this.eleccionSelected) {
          params.nombreeleccion = this.eleccionSelected;
        }

        // Cargar datos desde la API
        const response = await PagoVocalesService.getEstadisticas(params);

        // El backend responde un array de { total, estado }
        // Agrupamos los estados en las 4 categorías del dashboard
        const dataArray = Array.isArray(response) ? response : (response && response.data ? response.data : []);

        const enviadosATgr = ['RECIBIDA', 'DOCUMENTO_ENVIADO', 'DEPOSITO_ENVIADO', 'DEPOSITO_PROCESADO', 'ACEPTADA'];
        const conErrores = ['RECHAZADA', 'ANULADA', 'CREADO_CON_ERROR', 'REZAGADO_CON_ERROR'];
        const encolados = ['ENVIAR_COLA', 'ENCOLADO'];
        const creados = ['CREADO_VALIDO'];

        let totalEnviados = 0;
        let totalErrores = 0;
        let totalEncolados = 0;
        let totalCreados = 0;

        dataArray.forEach(item => {
          const totalNum = parseInt(item.total || 0, 10);
          const estado = item.estado;

          if (enviadosATgr.includes(estado)) {
            totalEnviados += totalNum;
          } else if (conErrores.includes(estado)) {
            totalErrores += totalNum;
          } else if (encolados.includes(estado)) {
            totalEncolados += totalNum;
          } else if (creados.includes(estado)) {
            totalCreados += totalNum;
          }
        });

        this.estadisticas = {
          creados: totalCreados,
          encolados: totalEncolados,
          enviados: totalEnviados,
          errores: totalErrores
        };
      } catch (error) {
        console.error('Error al cargar estadísticas:', error);
        // Establecer valores por defecto en caso de error
        this.estadisticas = {
          creados: 0,
          encolados: 0,
          enviados: 0,
          errores: 0
        };
      } finally {
        this.loadingInstance.close();
      }
    },
  }
};
</script>

<style scoped>
.v-card__title {
  word-break: normal;
}
</style>
